import styled, { css } from 'styled-components';
import theme from '../../styles/theme';

interface DropdownWrapperProps {
  variant?: string;
  status?: string;
}

interface ElementsProps {
  variant?: string;
}

export const DropdownContainer = styled.div<DropdownWrapperProps>`
  width: ${({ variant }) => (variant === 'xl' ? '50%' : '100%')};
  min-width: ${({ variant }) => (variant === 'xl' ? '50%' : '0')};
  max-width: ${({ variant }) => (variant === 'xl' ? '50%' : '100%')};
  flex: ${({ variant }) => (variant === 'xl' ? '0 0 50%' : '0 0 auto')};
  flex-shrink: 0;
`;

export const DropdownWrapper = styled.div<DropdownWrapperProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${({ variant }) => (variant === 'instrumentation' ? '0' : '8px')};
  align-items: ${({ variant }) => (variant === 'instrumentation' ? 'stretch' : 'flex-start')};
  height: 100%;
  margin-top: ${({ variant }) =>
    variant === 'xl'
      ? theme.spacing['spacing-2']
      : variant === 'instrumentation'
      ? '10px'
      : theme.spacing['spacing-2']};
  width: 100%;
  min-width: 0;
  flex: ${({ variant }) => (variant === 'xl' ? '1 1 50%' : '0 0 auto')};
  min-width: ${({ variant }) => (variant === 'xl' ? '50%' : '0')};
  button {
    width: 100%;
    min-width: ${({ variant }) => (variant === 'xl' ? '0' : '100%')};
    height: ${({ variant }) => (variant === 'instrumentation' ? '46px' : '52px')};
    min-height: ${({ variant }) => (variant === 'instrumentation' ? '46px' : '52px')};
    box-sizing: border-box;
    display: flex;
    align-items: center;
    line-height: ${({ variant }) => (variant === 'instrumentation' ? '46px' : 'initial')};
    padding: ${({ variant }) =>
      variant === 'instrumentation' ? `${theme.spacing['spacing-3']} ${theme.spacing['spacing-4']}` : undefined};
    color: ${({ status }) =>
      status === 'error'
        ? theme.colors.danger.text.regular
        : theme.colors.neutral.text.strong};
    background-color: ${theme.colors.neutral.bg.inverted};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 0 0 auto;
    
    > span {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      min-width: 0;
    }
  }
`;

export const Elements = styled.ul<ElementsProps>`
  border-radius: ${theme.borderRadius['border-radius-3']};
  box-shadow: ${theme.elevations['elevation-1']};
  margin-top: 4px;
  padding: ${theme.spacing['spacing-0']};
  background-color: ${theme.colors.neutral.bg.inverted};
  position: absolute;
  top: 100%;
  left: 0;
  text-align: left;
  max-height: 250px;
  min-height: 60px;
  height: fit-content;
  overflow-y: scroll;
  z-index: 10000;
  -ms-overflow-style: none;
  width: ${({ variant }) => (variant === 'xl' ? '100%' : '100%')};
  min-width: ${({ variant }) => (variant === 'xl' ? '100%' : '100%')};
  box-sizing: border-box;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: ${theme.spacing['spacing-2']} ${theme.spacing['spacing-3']};
  border: none;
  border-bottom: 1px solid ${theme.colors.neutral.border.regular};
  background-color: ${theme.colors.neutral.bg.inverted};
  color: ${theme.colors.neutral.text.strong};
  font-size: 14px;
  outline: none;
  position: sticky;
  top: 0;
  z-index: 1;
  
  &::placeholder {
    color: ${theme.colors.neutral.text.weak};
  }
  
  &:focus {
    border-bottom-color: ${theme.colors.primary.border.regular};
  }
`;

export const Element = styled.li`
  background-color: ${theme.colors.primary.bg.inverted};
  list-style-type: none;
  height: 36px;
  &:last-of-type {
    border-bottom-left-radius: ${theme.borderRadius['border-radius-3']};
    border-bottom-right-radius: ${theme.borderRadius['border-radius-3']};
  }

  &:hover,
  &:focus {
    cursor: pointer;
  }
`;

export const ElementButton = styled.button`
  border: none;
  background-color: ${theme.colors.primary.bg.inverted};
  padding: ${theme.spacing['spacing-1']} ${theme.spacing['spacing-5']};
  text-align: left;

  ${({ disabled }) => {
    if (disabled) {
      return css`
        cursor: not-allowed;
      `;
    } else {
      return css`
        cursor: pointer;
      `;
    }
  }}
`;
